import { Swiper } from './swiper-DDnfT8S0.js';
import { N as Navigation } from './navigation-DWrRZ7mI.js';
import { A as A11y } from './a11y-DMhWZZ38.js';
import { S as SwiperExt } from './swiper-BAqQR4kf.js';
import './utils-CPPFXbqB.js';
import './create-element-if-not-defined-BweCirD8.js';

class HeroBanner extends SwiperExt {
  swiperInstance = null;

  connectedCallback() {
    this.swiperInstance = new Swiper(this.querySelector('.swiper'), {
      modules: [Navigation, A11y],
      loop: true,
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
    });
  }
}

customElements.define('hero-banner', HeroBanner);
